import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SITE_NAME = 'Accolade';

export function DocumentTitle() {
    const { pathname } = useLocation();
    const { t } = useTranslation('common');

    useEffect(() => {
        const pageTitle = t(`pageTitles.${pathname}`, { defaultValue: '' });
        document.title = pageTitle ? `${SITE_NAME} | ${pageTitle}` : SITE_NAME;
    }, [pathname, t]);

    return null;
}